var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('heatmap-chart',{attrs:{"color":_vm.color,"title":_vm.direction === 'outbound' ? 'Outbound heatmap' : 'Voice heatmap',"data":_vm.data,"xAxis":_vm.xAxis,"yAxis":_vm.yAxis,"min":_vm.min,"max":_vm.max,"type":"voice"}})}
var staticRenderFns = []

export { render, staticRenderFns }